<template>
  <select v-model="mv"><slot /></select>
</template>

<script>
import date from 'locutus/php/datetime/date'

export default {
  props: ['modelValue'],
  emits: ['update:modelValue'],
  data() {
    return {
      ignoreCalendarChange: false,
    }
  },
  computed: {
    mv: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  watch: {
    modelValue: {
      handler: function (val) {
        if (val === 'custom') {
          return
        }

        const start = new Date()
        let end = new Date()
        end.setDate(start.getDate() + 7)

        switch (val) {
          case '1Y':
            end = new Date(start.getFullYear() + 1, start.getMonth(), start.getDate())
            break;
          
          case '1M':
            end = new Date(start.getFullYear() + (start.getMonth() === 12 ? 1 : 0), start.getMonth() === 12 ? 1 : start.getMonth() + 1, start.getDate())
            break;
          
          case '1W':
            // also default
            break;
        
          default:
            break;
        }

        this.ignoreCalendarChange = true
        this.$formValues['frm-sharingForm-sharingForm-valid_from'] = date('c', start)
        this.$formValues['frm-sharingForm-sharingForm-valid_to'] = date('c', end)
        this.$nextTick(() => {
          this.ignoreCalendarChange = false
        })
      },
      immediate: true,
    },
    '$formValues.frm-sharingForm-sharingForm-valid_from'(newVal, oldVal) {
      if (this.ignoreCalendarChange || (newVal && oldVal && newVal.substring(0, 10) === oldVal.substring(0, 10))) {
        return
      }
      
      this.mv = 'custom'
    },
    '$formValues.frm-sharingForm-sharingForm-valid_to'(newVal, oldVal) {
      if (this.ignoreCalendarChange || (newVal && oldVal && newVal.substring(0, 10) === oldVal.substring(0, 10))) {
        return
      }
      
      this.mv = 'custom'
    }
  }
}
</script>